import { gql } from '@apollo/client';

export const fetchWorkflowsTriggeredByOtherWorkflowsQuery = gql`
  query getWorkflowsTriggeredByOtherWorkflows {
    workflowsTriggeredByOtherWorkflows {
      results {
        id
        name
        workflowType
        enabled
      }
    }
  }
`;
